import React from 'react';
import type { NotificationsApi } from '@env0/notification-service/api';
import { useNotificationEndpointForm } from 'components/organizations/notifications/notification-endpoint-form.hook';
import ControlledTextInput from 'components/common/form-controlled/controlled-text-input';
import ControlledSelect from 'components/common/form-controlled/controlled-select';
import { NotificationEndpointType } from '@env0/notification-service/api.enum';
import { SelectOption } from 'components/common/input-components/select';
import ControlledModal from 'components/common/form-controlled/controlled-modal';
import styled from '@emotion/styled';

const prefix = 'organization.settings.notifications';

type Props = {
  endpoint?: NotificationsApi.NotificationEndpoint;
  onSubmitOrCancel: () => void;
};
const NotificationEndpointModal: React.FunctionComponent<Props> = ({ endpoint, onSubmitOrCancel }) => {
  const form = useNotificationEndpointForm(onSubmitOrCancel, endpoint);
  const notificationTypes = Object.values(NotificationEndpointType).filter(
    value => value !== NotificationEndpointType.WEBHOOK
  );
  const valueLabel = form.getValues('type') === NotificationEndpointType.EMAIL ? 'emailAddress' : 'value';

  return (
    <ControlledModal
      data-e2e="notification-endpoint-modal"
      form={form}
      onCancel={onSubmitOrCancel}
      titleId={`${endpoint ? 'organization.settings.notifications.edit' : 'addNotificationTarget'}`}
      open>
      <InputContainer>
        <ControlledTextInput label={{ id: `${prefix}.name` }} name="name" form={form} />
      </InputContainer>

      <InputContainer>
        <ControlledSelect
          data-e2e="notification-options"
          label={{ id: `${prefix}.type` }}
          name="type"
          form={form}
          hideError>
          {notificationTypes.map(value => (
            <SelectOption key={value} value={value}>
              {value}
            </SelectOption>
          ))}
        </ControlledSelect>
      </InputContainer>

      <InputContainer data-e2e="notification-value">
        <ControlledTextInput label={{ id: `${prefix}.${valueLabel}` }} name="value" form={form} />
      </InputContainer>
    </ControlledModal>
  );
};

const InputContainer = styled.div`
  height: 5em;
`;

export default NotificationEndpointModal;
